module.exports = __webpack_public_path__ + "media/images/row4_img-da5f4725ecf4f66da130dd2fa41ddad4.jpg";